import { render, staticRenderFns } from "./PurimAddBulkHours.vue?vue&type=template&id=019a0846&"
import script from "./PurimAddBulkHours.vue?vue&type=script&lang=js&"
export * from "./PurimAddBulkHours.vue?vue&type=script&lang=js&"
import style0 from "./PurimAddBulkHours.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports